<template>
  <header class="header" :class="{ 'widescreen-padding': display.lgAndUp }">
    <div class="first-line">
      <img src="/assets/logo-text-only.png" alt="Menu Icon" class="logo-section" :class="display.mdAndUp ? 'logo-text' : 'logo-text-small'"
        @click="logoClick" />
    </div>
  </header>
</template>

<script>
import { useDisplay } from 'vuetify';

export default {
  data() {
    return {
      errorMessage: "",
      display: {}
    };
  },
  async mounted() {
    this.display = useDisplay();
  },
  methods: {
    logoClick() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.header {
  height: 6vh;
  width: 100% - 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: var(--bg);
  color: var(--text-primary);
  padding-top: 7px;
  padding-right: 20px;
  padding-left: 20px;
}

.widescreen-padding {
  padding-right: 50px;
  padding-left: 50px;
}

.first-line {
  width: 100%;
  display: flex;
}

.logo-text {
  height: 24px;
  cursor: pointer;
}

.logo-text-small {
  height: 18px;
}

.logo-section {
  cursor: pointer;
  margin-top: 5px;
  margin-left: 5px;
}
</style>
